// Tiny logger that the lint rule `no-console` allows through.
// Keeps committed code free of stray console.log calls while still surfacing real diagnostics.

type Level = "debug" | "info" | "warn" | "error";

const enabled = (level: Level): boolean => {
  if (level === "debug") return import.meta.env.DEV;
  return true;
};

function emit(level: Level, args: unknown[]): void {
  if (!enabled(level)) return;
  const target = level === "error" ? console.error : level === "warn" ? console.warn : console.warn;
  target(`[flow:${level}]`, ...args);
}

export const log = {
  debug: (...args: unknown[]) => emit("debug", args),
  info: (...args: unknown[]) => emit("info", args),
  warn: (...args: unknown[]) => emit("warn", args),
  error: (...args: unknown[]) => emit("error", args),
};
